import { Link } from "react-router-dom";
import { useConfig, waLink } from "@/context/ConfigContext";
import { MessageCircle } from "lucide-react";

export function WhatsAppButton() {
  const config = useConfig();
  const href = waLink(config.whatsapp);
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-forest px-4 py-3 text-white shadow-xl transition-transform duration-300 hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="hidden font-accent text-sm font-semibold sm:inline">WhatsApp</span>
    </a>
  );
}
